import { ShieldCheck, Banknote, Truck, Sparkles, Gift } from "lucide-react";
import { Reveal } from "./Reveal";

const cards = [
  {
    icon: ShieldCheck,
    title: "Agréé toutes assurances",
    desc: "Nous gérons directement le dossier avec votre compagnie d'assurance, de A à Z.",
    testid: "advantage-card-assurances",
  },
  {
    icon: Banknote,
    title: "Aucune avance de frais",
    desc: "0€ à avancer : nous facturons directement votre assureur. Simple et transparent.",
    testid: "advantage-card-avance",
  },
  {
    icon: Truck,
    title: "Déplacement gratuit",
    desc: "Intervention à domicile gratuite sur Bordeaux & toute sa métropole.",
    testid: "advantage-card-domicile",
  },
  {
    icon: Sparkles,
    title: "Rapide & propre",
    desc: "Techniciens certifiés, chantier impeccable et garantie d'étanchéité à vie.",
    testid: "advantage-card-rapide",
  },
];

export const Advantages = () => (
  <section id="avantages" data-testid="advantages-section" className="relative bg-[#050505] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D4AF37]">Pourquoi Motor Select</p>
        <h2 className="mt-4 font-display text-4xl uppercase text-white sm:text-5xl lg:text-6xl">
          Des avantages qui font <span className="text-gold-gradient">la différence</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Reveal className="md:col-span-2 lg:col-span-1 lg:row-span-2">
          <div
            data-testid="advantage-card-offer"
            className="group relative flex h-full flex-col justify-between gap-10 overflow-hidden rounded-2xl border border-[#D4AF37]/40 bg-gradient-to-b from-[#17150a] to-[#0D0D0F] p-8 gold-ring-glow"
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#D4AF37]/15 blur-[80px] transition-opacity duration-700 group-hover:opacity-100" />
            <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-[#D4AF37]/40 bg-[#D4AF37]/10">
              <Gift className="h-7 w-7 text-[#D4AF37]" />
            </div>
            <div>
              <p className="font-display text-7xl leading-none text-gold-gradient sm:text-8xl">200€</p>
              <p className="mt-4 text-lg font-semibold text-white">Jusqu'à 200€ offerts*</p>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">
                + plein de cadeaux offerts à chaque remplacement de pare-brise. *Voir conditions sur demande.
              </p>
            </div>
          </div>
        </Reveal>

        {cards.map((c, i) => (
          <Reveal key={c.title} delay={0.08 * (i + 1)}>
            <div
              data-testid={c.testid}
              className="group h-full rounded-2xl border border-white/10 bg-[#0D0D0F] p-8 transition-colors duration-500 hover:border-[#D4AF37]/50"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 transition-colors duration-500 group-hover:border-[#D4AF37]/40 group-hover:bg-[#D4AF37]/10">
                <c.icon className="h-6 w-6 text-[#D4AF37]" />
              </div>
              <h3 className="mt-6 font-heading text-xl font-bold text-white">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{c.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
